import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["currentPage", "totalPages", "length"];
import { jsxs as d, jsx as n } from "react/jsx-runtime";
import { c } from "../clsx-OuTLNxxd.js";
import { PaginationButton as l } from "../PaginationButton/PaginationButton.js";
import { getPaginationItems as r, SEPARATOR1 as _, SEPARATOR2 as u } from "./utils.js";
const v = "Pagination-module_container__JHnDH",
  x = "Pagination-module_list__1fx5U",
  C = "Pagination-module_item__mPNER",
  f = "Pagination-module_page-button__x9RD3",
  k = "Pagination-module_active__sp--Y",
  o = {
    container: v,
    list: x,
    item: C,
    pageButton: f,
    active: k
  },
  R = _ref => {
    let {
        currentPage: t,
        totalPages: e,
        length: s
      } = _ref,
      a = _objectWithoutProperties(_ref, _excluded);
    const m = r(t, e, s);
    return /* @__PURE__ */d("div", {
      className: o.container,
      "data-content-name": "pagination",
      children: [/* @__PURE__ */n("div", {
        children: /* @__PURE__ */n(l, {
          disabled: t == 1,
          onClick: () => a.onClick(t - 1),
          arrow: "left",
          dataContentPiece: "prev"
        })
      }, "prev"), /* @__PURE__ */n("ul", {
        className: o.list,
        children: m.map(i => i == _ || i == u ? /* @__PURE__ */n("li", {
          className: c(o.item),
          children: "…"
        }, i) : /* @__PURE__ */n("li", {
          className: c(o.item, {
            [o.active]: t == i,
            [o.activeSibling]: i == t - 1
          }),
          children: /* @__PURE__ */n("button", {
            className: o.pageButton,
            onClick: () => a.onClick(i),
            "data-content-piece": "page__".concat(i),
            children: i
          })
        }, i))
      }), /* @__PURE__ */n("div", {
        children: /* @__PURE__ */n(l, {
          disabled: t == e,
          onClick: () => a.onClick(t + 1),
          arrow: "right",
          dataContentPiece: "next"
        })
      }, "next")]
    });
  };
export { R as Pagination };